import { useReadQuery } from '@apollo/client';
import { StreamDecksQueryQuery } from '@/__generated__/graphql';
import { StreamDeck } from '@/__generated__/schema-types.ts';
import { useAuthenticatedAppLoader } from './loader';

export const useStreamDecks = () => {
  const data = useAuthenticatedAppLoader();

  const {
    data: { streamDecks },
  } = useReadQuery<StreamDecksQueryQuery>(data.streamDecksQueryRef);

  return (streamDecks || []) as StreamDeck[];
};
